export default function DisplayFrameScreen() {
    return (
<svg viewBox="0 0 1051.6 908.6">
  <path d="m650 778.2-.5 4.4s3.1 18.9-23 18.9H425.6c-26.1 0-23-18.9-23-18.9l.5-4.4Z" fill="#808184"/>
  <path d="M953.4 610.5v66a17 17 0 0 1-17 17H115.7a17 17 0 0 1-17-17v-66Z" fill="#929497" opacity=".7"/>
  <path fill="#808184" d="M442.9 693.4h167.4v18.8H442.9z"/>
  <path d="M936.4 106.5H115.7a17 17 0 0 0-17 17v553a17 17 0 0 0 17 17h820.7a17 17 0 0 0 17-17v-553a17 17 0 0 0-17-17Zm-19 471H135.7v-441h781.5ZM610.3 712.3l39.7 65.9s3.1 18.8-23 18.8H426.1c-26.1 0-23-18.8-23-18.8l39.8-66Z" fill="#929497"/>
</svg>
    )
}
